/*
 * <discount-badge>: keeps the discount badge on the product page in sync with
 * the selected variant. Rendered by snippets/discount-badge.liquid.
 *
 * The badge listens for `change` events from the variant picker
 * (<variant-radios> / <variant-selects>) of the same section and reads the
 * picker's `currentVariant` (price and compare_at_price in cents).
 */
if (!customElements.get('discount-badge')) {
  customElements.define(
    'discount-badge',
    class DiscountBadge extends HTMLElement {
      constructor() {
        super();
        this.onPickerChange = this.onPickerChange.bind(this);
      }

      connectedCallback() {
        if (!this.dataset.section) return;
        document.addEventListener('change', this.onPickerChange);
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onPickerChange);
      }

      onPickerChange(event) {
        const picker = event.target.closest('variant-radios, variant-selects');
        if (!picker || picker.dataset.section !== this.dataset.section) return;
        this.update(picker.currentVariant);
      }

      update(variant) {
        const percentage = DiscountBadge.percentage(variant);
        if (!percentage) {
          this.hidden = true;
          return;
        }

        const text = `-${percentage}%`;
        const value = this.querySelector('[data-discount-value]');
        if (value) {
          value.textContent = text;
          value.setAttribute('textLength', 68 + (text.length - 3) * 24);
        }

        const label = this.querySelector('[data-discount-label]');
        if (label && this.dataset.labelTemplate) {
          label.textContent = this.dataset.labelTemplate.replace('[percentage]', percentage);
        }

        this.hidden = false;
      }

      static percentage(variant) {
        if (!variant || !variant.available) return 0;
        const compareAt = Number(variant.compare_at_price);
        const price = Number(variant.price);
        if (!compareAt || compareAt <= price) return 0;
        return Math.round(((compareAt - price) / compareAt) * 100);
      }
    }
  );
}
